import './index.scss'

import Sidebar from '../Sidebar';

import React, { Component } from 'react';
import CardList from './portfolioComponents/CardList';
import SearchBox from './portfolioComponents/SearchBox';
import {projects} from './portfolioComponents/Project';
import Scroll from './portfolioComponents/Scroll';

class Portfolio extends Component {
  constructor(){
    super()
    this.state = {
      projects: projects,
      searchfield: ''
    }
  }

  componentDidMount(){
    fetch('https://jsonplaceholder.typicode.com/users')
    .then(response=>{
      return response.json();
    })
    .then(users =>{
      this.setState({projects: projects})
    })
  }

  onSearchChange = (event) => {
    this.setState({ searchfield: event.target.value})
  }

  render(){
    const { projects, searchfield } = this.state;
    const filteredItems = this.state.projects.filter(projects => {
      return projects.name.toLowerCase().includes(searchfield.toLowerCase())
    })
    if(projects.length === 0){
      return <h1> Loading </h1>
    }
    else {
      return (
        <div>
        <Sidebar/>
          <div className='tc'>
            <h1 className='f2'> Projects </h1>
            <SearchBox searchChange={this.onSearchChange}/>
            <Scroll>
              <CardList items={filteredItems}/>
            </Scroll>
          </div>
          </div>
      );
    }
  }
}

export default Portfolio
